import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@sb/library/button';
import { SnackbarModule } from '@sb/library/snackbar';
import { ClipboardCardScrollComponent } from './clipboard-card-scroll/clipboard-card-scroll.component';
import { ClipboardCardComponent } from './clipboard-card/clipboard-card.component';
import { ClipboardComponent } from './clipboard.component';

@NgModule({
    declarations: [
        ClipboardComponent,
        ClipboardCardComponent,
        ClipboardCardScrollComponent
    ],
    imports: [
        CommonModule,
        SnackbarModule,
        ButtonModule
    ],
    exports: [
        ClipboardComponent,
        ClipboardCardComponent,
        ClipboardCardScrollComponent
    ]
})
export class ClipboardModule { }
